import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import BreadcrumbSingleProducts from "../BreadcrumbSingleProducts";
import SingleProductDetails from "./SingleProductDetails";
import ReviewDesc from "./ReviewDesc";
import RandomProducts from "./RandomProducts";
import back from "../../images/widget-background.webp";

const SingleProduct = () => {
  const [product, setProduct] = useState([]);
  const [mainRef, setMainRef] = useState(null);
  const [thumbRef, setThumbRef] = useState(null);
  const [location, setLocation] = useState([]);
  const [state, setState] = useState("Abia");
  const [city, setCity] = useState("");
  const [details, setDetails] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    fetch("/products.json")
      .then((res) => res.json())
      .then((data) => setProduct(data));
  }, []);

  const mainProduct = product.filter((p) => p.id === id);
  console.log(mainProduct);

  // Splide
  useEffect(() => {
    if (mainRef && thumbRef) {
      mainRef.sync(thumbRef);
    }
  }, [mainRef, thumbRef]);

  // location
  useEffect(() => {
    fetch("https://temikeezy.github.io/nigeria-geojson-data/data/full.json")
      .then((res) => res.json())
      .then((data) => setLocation(data));
  }, []);
  // console.log(location);
  details
    ? (document.body.style.overflowY = "hidden")
    : (document.body.style.overflowY = "auto");

  const selectedCity = location.find((locate) => locate.state === state);
  return (
    <div>
      {mainProduct.map((main) => (
        <BreadcrumbSingleProducts
          categ={main.category}
          curPage={main.name}
          key={main.id}
        />
      ))}
      <div className="flex flex-col lg:flex-row items-start gap-6 py-[50px] px-[20px]">
        <div className="w-[100%] lg:w-[70%]">
          {mainProduct.map((main, i) => (
            <div
              key={i}
              className="flex flex-col lg:flex-row gap-2 items-start shadow-md rounded-[5px] my-[20px]"
            >
              <div className="w-[100%] lg:w-[50%]">
                <Splide
                  options={{
                    type: "loop",
                    width: "100%",
                    height: 300,
                    pagination: false,
                  }}
                  onMounted={(splide) => setMainRef(splide)}
                >
                  <SplideSlide className={"h-[100%]"}>
                    <img
                      src={main.image}
                      alt={main.id}
                      className="h-[100%] relative left-[50%] translate-x-[-50%]"
                    />
                  </SplideSlide>
                  <SplideSlide className={"h-[100%]"}>
                    <img
                      src={main.image2}
                      alt={main.id}
                      className="h-[100%] relative left-[50%] translate-x-[-50%]"
                    />
                  </SplideSlide>
                  <SplideSlide className={"h-[100%]"}>
                    <img
                      src={main.image3}
                      alt={main.id}
                      className="h-[100%] relative left-[50%] translate-x-[-50%]"
                    />
                  </SplideSlide>
                </Splide>

                {/* Thumbnail */}
                <Splide
                  options={{
                    perPage: 3,
                    isNavigation: true,
                    pagination: false,
                    arrows: false,
                    height: 200,
                    width: 200,
                  }}
                  onMounted={(splide) => setThumbRef(splide)}
                >
                  <SplideSlide>
                    <img src={main.image} alt={main.id} />
                  </SplideSlide>
                  <SplideSlide>
                    <img src={main.image2} alt={main.id} />
                  </SplideSlide>
                  <SplideSlide>
                    <img src={main.image3} alt={main.id} />
                  </SplideSlide>
                </Splide>
              </div>

              {/* Product Details */}
              {mainProduct.map((main) => (
                <SingleProductDetails main={main} key={main.id} id={id} />
              ))}
            </div>
          ))}
          {/* Review & Description */}
          <ReviewDesc />
        </div>
        {/* Right part */}
        <div className="w-[100%] lg:w-[30%] flex flex-col gap-3">
          <div className="shadow-lg p-[30px] rounded-[5px]">
            <h3 className="font-[600] text-[17px] my-[5px]">
              DELIVERY & RETURNS
            </h3>
            <form>
              <label htmlFor="location" className="text-gray-500">
                Choose Your Location
              </label>
              <br />
              <select
                className="my-[5px] w-[90%] border-[1px] py-[5px] px-[10px]"
                name="state"
                id="location"
                value={state}
                onChange={(e) => setState(e.target.value)}
              >
                {location.map((locate, i) => (
                  <option key={i} value={locate.state}>
                    {locate.state}
                  </option>
                ))}
              </select>
              <br />
              <select
                className="my-[5px] w-[90%] border-[1px] py-[5px] px-[10px]"
                name="city"
                id="location"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              >
                {selectedCity?.lgas?.map((locat, i) => (
                  <option key={i} value={locat.name}>
                    {locat.name}
                  </option>
                ))}
              </select>
            </form>
            <div className="flex items-start gap-2 border-[1px] border-gray-300 p-[20px] w-[100%] my-[20px] relative">
              <i className="fa-solid fa-truck-pickup relative top-[10px] text-amber-500"></i>
              <div className="w-[90%]">
                <h3 className="font-[600]">Pickup</h3>
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit.</p>
                <span
                  className="absolute top-[9%] left-[83%] text-[14px] cursor-pointer"
                  onClick={() => setDetails(true)}
                >
                  Details
                </span>
              </div>
            </div>
            <div className="flex items-start gap-2 border-[1px] border-gray-300 p-[20px] w-[100%] my-[20px] relative">
              <i className="fa-solid fa-truck-pickup relative top-[10px] text-amber-500"></i>
              <div className="w-[90%]">
                <h3 className="font-[600]">Door Delivery</h3>
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit.</p>
                <span
                  className="absolute top-[9%] left-[83%] text-[14px] cursor-pointer"
                  onClick={() => setDetails(true)}
                >
                  Details
                </span>
              </div>
            </div>
            <div className="flex items-start gap-2 border-[1px] border-gray-300 p-[20px] w-[100%] my-[20px] relative">
              <i className="fa-solid fa-truck-pickup relative top-[10px] text-amber-500"></i>
              <div className="w-[90%]">
                <h3 className="font-[600]">Return Policy</h3>
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit.</p>
                <span
                  className="absolute top-[9%] left-[83%] text-[14px] cursor-pointer"
                  onClick={() => setDetails(true)}
                >
                  Details
                </span>
              </div>
            </div>
          </div>
          {/*  */}
          <div className="shadow-lg p-[30px] rounded-[5px] mt-[30px]">
            <RandomProducts products={product} back={back} />
          </div>
        </div>
      </div>

      {/* Floater Popup */}
      <div
        className={`${
          details
            ? "fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] bg-white flex flex-col items-center justify-center h-[300px] w-[500px] shadow-md z-[100]"
            : "hidden"
        }`}
      >
        <h3>Pickup Details....</h3>
        <button
          onClick={() => setDetails(false)}
          className="absolute top-[10%] left-[90%]"
        >
          <i className="fa-solid fa-x"></i>
        </button>
      </div>
      <div
        className={`${
          details
            ? "fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] h-[100%] w-[100%] bg-[#80808038] z-50"
            : ""
        }`}
        onClick={() => setDetails(false)}
      ></div>
    </div>
  );
};

export default SingleProduct;
